/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { addThrottledEvent } from '@msdyn365-commerce-modules/utilities';
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import * as React from 'react';
import { IDobbiesSideNavigationMenuViewProps } from './dobbies-side-navigation-menu';
import MsDyn365, * as Msdyn365 from '@msdyn365-commerce/core';
// import DobbiesModal from '../../themes/dobbies/views/custom-components/dobbies-modal';
import { ISubMenuStaticMenusData } from '../dobbies-navigation-menu/dobbies-navigation-menu.props.autogenerated';
import { getLocalStorage } from '../../themes/dobbies/utilities/storage';

export default (props: IDobbiesSideNavigationMenuViewProps) => {
    // const [activeCategory, setActiveCategory] = React.useState<CategoryHierarchy | undefined>(undefined);
    const [categoryChildren, setCategoryChildren] = React.useState<CategoryHierarchy[] | undefined>(undefined);
    // const [isMobile, setIsMobile] = React.useState(false);
    const [screenSize, setScreenSize] = React.useState(0);
    const [showModal, setShowModal] = React.useState(false);

    React.useEffect(() => {
        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key.toLocaleLowerCase() === 'escape') {
                if (showModal) {
                    setShowModal(!showModal);
                }
            }
        });
    }, [showModal]);

    // const modalTitle = (): JSX.Element => {
    //     // const categoryName = categories && categories.result && categories.result.Name;
    //     const handleShowModal = () => setShowModal(!showModal);
    //     return (
    //         <Node tag='div' className='view-all-popup-header'>
    //             <Node tag='span' className='title-text'>
    //                 {activeCategory?.Name}
    //             </Node>
    //             <div className='header-close-button' onClick={handleShowModal} role='button'>
    //                 <i className='msc-modal__close-button' />
    //             </div>
    //         </Node>
    //     );
    // };
    // const modalFooter = (): JSX.Element => {
    //     const handleShowModal = () => setShowModal(!showModal);
    //     return <div className='close-button' role='button' onClick={handleShowModal} />;
    // };
    // const _modalToggle = () => {
    //     setShowModal(!showModal);
    // };
    // const renderToggle = (): JSX.Element | undefined => {
    //     const handleShowModal = () => setShowModal(!showModal);
    //     return (
    //         <>
    //             <div className='category-list-mobile'>
    //                 {/* <h1 className='category-listing-title'>{activeCategory?.Name}</h1> */}
    //                 <button onClick={handleShowModal}>View All</button>
    //             </div>
    //             <DobbiesModal
    //                 className='modal ms-dobbies-browse'
    //                 isOpen={showModal}
    //                 modalBodyElement={renderMobileNav()}
    //                 onModalToggle={_modalToggle}
    //                 modalTitle={modalTitle()}
    //                 modalFooter={modalFooter()}
    //             />
    //         </>
    //     );
    // };

    // const renderMobileNav = (): JSX.Element | undefined => {
    //     return (
    //         <div className='category-listing'>
    //             <ul>{categoryChildren && categoryChildren.map(category => renderCategories(category, props))}</ul>
    //         </div>
    //     );
    // };

    // const renderCategories = (category: CategoryHierarchy, props: IDobbiesSideNavigationMenuViewProps): JSX.Element => {
    //     if (category.Children && category.Children.length > 0) {
    //         return (
    //             <div>
    //                 <li className='category-heading' key={category.RecordId}>
    //                     <a href={category.Url}>{category.Name}</a>
    //                 </li>
    //                 {category.Children.map(category => (
    //                     <li key={category.RecordId}>
    //                         <a href={category.Url}>{category.Name}</a>
    //                     </li>
    //                 ))}
    //             </div>
    //         );
    //     }

    //     return (
    //         <li className='category-heading' key={category.RecordId}>
    //             <a href={category.Url}>{category.Name}</a>
    //         </li>
    //     );
    // };

    React.useEffect(() => {
        setMobileView();
        window && addThrottledEvent(window, 'resize', setMobileView);
    });

    const setMobileView = () => {
        // const _isMobile = isMobileView(props.context);
        // // setIsMobile(_isMobile);
    };

    React.useEffect(() => {
        const isMbl = _getScreenSize(props.context);
        setScreenSize(isMbl);
    });

    React.useEffect(() => {
        const getCategories = async () => {
            const pathnames = props.context.request.url.requestUrl.pathname.split('/');
            const pathname = pathnames[pathnames.length - 1];

            const categoryId = props.config.categoryId ? props.config.categoryId : pathname.replace('.c', '');
            const categoryIdL2 = props.config.categoryLevelTwo;
            const categories = await props.data.categories;

            let activeCategory = categories!.filter(category => categoryId.toString() === category.RecordId.toString());
            if (categoryIdL2) {
                activeCategory = activeCategory[0].Children.filter(cat => categoryIdL2.toString() === cat.RecordId.toString());
            }

            if (activeCategory[0] && activeCategory[0]) {
                // setActiveCategory(activeCategory[0]);
                if (!categoryChildren) {
                    setCategoryChildren(
                        activeCategory[0].Children.filter(cat => !shouldCategoryHide(props, cat.NeutralizedName)).concat(
                            getStaticCategories(props, activeCategory[0])
                        )
                    );
                }
            }
        };
        getCategories();
        if (MsDyn365.isBrowser) {
            window.addEventListener('resize', () => {
                const isMbl = _getScreenSize(props.context);
                setScreenSize(isMbl);
            });
        }
    }, []);

    const getMaxCategoriesForCurrentScreenSize = () => {
        if (MsDyn365.isBrowser && window) {
            if (window.innerWidth >= 1700) {
                return 4;
            } else if (window.innerWidth >= 1250 && window.innerWidth < 1700) {
                return 3;
            } else if (window.innerWidth >= 700 && window.innerWidth < 1250) {
                return 2;
            } else if (window.innerWidth < 700) {
                return 1;
            }
        }
        return -1;
    };

    const _getScreenSize = (ctx: Msdyn365.ICoreContext): number => {
        // always render in mobile viewport on a mobile device
        // if (ctx.request && ctx.request.device && ctx.request.device.Type === 'Mobile') {
        //     return 1;
        // }

        if (typeof window !== undefined && window.innerWidth) {
            const gridSettings = ctx.request.gridSettings;
            if (gridSettings) {
                if (window.innerWidth < 768) {
                    // mobile
                    return 1;
                } else if (window.innerWidth < 1476) {
                    // iPad
                    return 2;
                } else if (window.innerWidth >= 1476) {
                    // Desktop
                    return 3;
                } else {
                    return 3;
                }
                //  else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
                //     // Desktop
                //     return 3;
                // }
            }
        }

        return 3; // desktop
    };

    // const isMobileView = (context: Msdyn365.ICoreContext): boolean => {
    //     // always render in mobile viewport on a mobile device
    //     /* if (context.request && context.request.device && context.request.device.Type === 'Mobile') {
    //         return true;
    //     } */

    //     if (typeof window !== undefined && window.innerWidth) {
    //         const gridSettings = context.request.gridSettings;
    //         if (gridSettings) {
    //             if (gridSettings.xs && window.innerWidth < gridSettings.xs.w) {
    //                 return true;
    //             } else if (gridSettings.sm && window.innerWidth < gridSettings.sm.w) {
    //                 return true;
    //             } else if (gridSettings.md && window.innerWidth <= gridSettings.md.w) {
    //                 return false;
    //             } else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
    //                 return false;
    //             } else {
    //                 return false;
    //             }
    //         }
    //     }

    //     return false;
    // };

    const getSubMenus = (category: ISubMenuStaticMenusData) => {
        const subMenus: CategoryHierarchy[] = [];
        if (category.subMenus && category.subMenus.length) {
            for (const sbm of category.subMenus) {
                const c: CategoryHierarchy = { Name: sbm.linkText, Url: sbm.linkUrl.destinationUrl, Children: [], RecordId: -1 };
                subMenus.push(c);
            }
        }
        return subMenus;
    };

    const getStaticCategories = (props: IDobbiesSideNavigationMenuViewProps, category: CategoryHierarchy) => {
        const staticMenusLS = getLocalStorage('static_submenu_items');
        let staticMenuJSONObj;
        if (staticMenusLS) {
            staticMenuJSONObj = JSON.parse(staticMenusLS);
        }
        let staticMenus: ISubMenuStaticMenusData[] = [];
        const staticCategories: CategoryHierarchy[] = [];
        if (Array.isArray(staticMenuJSONObj)) {
            staticMenus = staticMenuJSONObj as ISubMenuStaticMenusData[];
        }
        const lastCategory = category;
        staticMenus = staticMenus.filter(sm => sm.linkText === lastCategory.Name && sm.subMenus?.length);
        staticMenus.map(sm => {
            sm.subMenus?.map(sbm => {
                const c: CategoryHierarchy = {
                    Name: sbm.linkText,
                    Url: sbm.linkUrl.destinationUrl,
                    Children: getSubMenus(sbm),
                    RecordId: -1
                };
                staticCategories.push(c);
            });
        });
        return staticCategories;
    };

    const shouldCategoryHide = (props: IDobbiesSideNavigationMenuViewProps, neutralizedName?: string): boolean => {
        if (props.config.hideMenuItemPrefix && neutralizedName?.startsWith(props.config.hideMenuItemPrefix)) {
            return true;
        }
        return false;
    };

    const replaceCategory = (props: IDobbiesSideNavigationMenuViewProps, category: CategoryHierarchy): CategoryHierarchy => {
        if (props.config.categoriesReplacementPriorityList && props.config.categoriesReplacementPriorityList.length) {
            for (const replacementInfo of props.config.categoriesReplacementPriorityList) {
                if (replacementInfo.categoryToBeReplaced === category.Name) {
                    category.Name = replacementInfo.replacingCategory;
                    category.Url = replacementInfo.replacingCategoryUrl;
                    return category;
                }
            }
        }
        return category;
    };

    const renderLinks = (
        category: CategoryHierarchy,
        props: IDobbiesSideNavigationMenuViewProps,
        isFromMoreOptions?: boolean
    ): JSX.Element => {
        return (
            <a key={category.RecordId} href={category.Url} className={`category-pill`}>
                {category.Name}
            </a>
        );
    };
    console.log('Screen Size', screenSize);
    let maxCategories = getMaxCategoriesForCurrentScreenSize(); // screenSize === 3 ? 4 : screenSize === 2 ? 3 : 0;
    if (maxCategories === -1) {
        return <></>;
    }
    // maxCategories = screenSize === 1 ? 2 : maxCategories;
    const characterLimit = props.config.maximumCharacterLimit;

    if (categoryChildren?.length && categoryChildren?.length > maxCategories) {
        let maxLengthCheckIter = 0;
        for (const cat of categoryChildren) {
            if (characterLimit && cat.Name?.length && cat.Name?.length > characterLimit && maxLengthCheckIter < maxCategories) {
                maxCategories = maxCategories - 1;
                break;
            }
            maxLengthCheckIter++;
        }
    }

    if (categoryChildren?.length === maxCategories + 1) {
        maxCategories = maxCategories + 1;
    }
    const scrollRef = React.useRef<HTMLDivElement>(null);

    const [isAtStart, setIsAtStart] = React.useState(true);
    const [isAtEnd, setIsAtEnd] = React.useState(false);

    const checkScrollPosition = () => {
        const el = scrollRef.current;
        if (!el) {
            return;
        }

        const atStart = el.scrollLeft <= 0;

        const atEnd = el.scrollWidth <= el.clientWidth || el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

        setIsAtStart(atStart);
        setIsAtEnd(atEnd);
    };

    React.useEffect(() => {
        const el = scrollRef.current;
        if (!el) {
            return;
        }

        const update = () => checkScrollPosition();

        requestAnimationFrame(update);

        const timeout = setTimeout(update, 120);

        el.addEventListener('scroll', checkScrollPosition);
        window.addEventListener('resize', update);

        return () => {
            el.removeEventListener('scroll', checkScrollPosition);
            window.removeEventListener('resize', update);
            clearTimeout(timeout);
        };
    }, [props.data.categories?.result]);

    const scroll = (direction: 'left' | 'right') => {
        if (!scrollRef.current) {
            return;
        }
        const container = scrollRef.current;
        const items = Array.from(container.querySelectorAll<HTMLElement>('.category-pill'));
        if (!items.length) {
            const fallbackAmount = container.clientWidth * 0.8;
            container.scrollBy({ left: direction === 'right' ? fallbackAmount : -fallbackAmount, behavior: 'smooth' });
            return;
        }

        const currentScroll = container.scrollLeft;

        const navButtonWidth = 28; // px
        const viewLeft = currentScroll + navButtonWidth + 1;
        let currentIndex = items.findIndex(item => item.offsetLeft <= viewLeft && item.offsetLeft + item.offsetWidth > viewLeft);

        if (currentIndex === -1) {
            currentIndex = items.findIndex(item => item.offsetLeft > viewLeft);
            if (currentIndex === -1) {
                currentIndex = items.length - 1;
            }
        }

        const targetIndex = direction === 'right' ? Math.min(items.length - 1, currentIndex + 1) : Math.max(0, currentIndex - 1);
        if (direction === 'left' && targetIndex === 0) {
            container.scrollTo({ left: 0, behavior: 'smooth' });
            return;
        }

        const targetItem = items[targetIndex];
        let targetScrollLeft = targetItem.offsetLeft - navButtonWidth;
        if (targetScrollLeft < 0) {
            targetScrollLeft = 0;
        }
        container.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
    };
    const hasCategories = !!categoryChildren?.length;

    return (
        <div className='category-listing'>
            <div className={`category-slider-wrapper${!hasCategories ? ' d-none' : ''}`}>
                <button className={`nav-btn left ${isAtStart ? 'disabled' : ''}`} onClick={() => scroll('left')} disabled={isAtStart}>
                    left
                </button>
                <div className='category-slider' ref={scrollRef}>
                    {categoryChildren && categoryChildren.map(category => renderLinks(replaceCategory(props, category), props))}
                </div>
                <button className={`nav-btn right ${isAtEnd ? 'disabled' : ''}`} onClick={() => scroll('right')} disabled={isAtEnd}>
                    right
                </button>
            </div>
        </div>
    );
};
